<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 17 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.5 0.5625C8.93147 0.5625 9.28125 0.912278 9.28125 1.34375L9.28125 6.8125H7.71875V1.34375C7.71875 0.912277 8.06853 0.5625 8.5 0.5625Z"
                :fill="color" 
            />
            <path
                d="M7.71875 6.8125L7.71875 12.7389L5.92743 10.9476C5.62233 10.6425 5.12767 10.6425 4.82257 10.9476C4.51748 11.2527 4.51748 11.7473 4.82257 12.0524L7.94757 15.1774C8.09408 15.3239 8.2928 15.4062 8.5 15.4062C8.7072 15.4062 8.90591 15.3239 9.05243 15.1774L12.1774 12.0524C12.4825 11.7473 12.4825 11.2527 12.1774 10.9476C11.8723 10.6425 11.3777 10.6425 11.0726 10.9476L9.28125 12.7389V6.8125H13.1875C14.9134 6.8125 16.3125 8.21161 16.3125 9.9375V19.3125C16.3125 21.0384 14.9134 22.4375 13.1875 22.4375H3.8125C2.08661 22.4375 0.6875 21.0384 0.6875 19.3125V9.9375C0.6875 8.21161 2.08661 6.8125 3.8125 6.8125H7.71875Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgDownloads',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>